import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarPlus, ListPlus, CalendarDays } from "lucide-react";
import { addMealToPlan, addToGrocery, savePlan, DAYS } from "../lib/planner";
import { track } from "../lib/analytics";

const toItems = (pairs) => pairs.map(([text, aisle]) => ({ text, aisle }));

const useFlash = () => {
  const [msg, setMsg] = useState("");
  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(""), 2200); };
  return [msg, flash];
};

// Action buttons under a collection recipe card — wires it into the planner + grocery list.
export const RecipeActions = ({ collectionSlug, recipe }) => {
  const [msg, flash] = useFlash();
  const [picking, setPicking] = useState(false);
  const navigate = useNavigate();
  const id = `${collectionSlug}/${recipe.slug}`;

  if (recipe.week) {
    const loadWeek = () => { savePlan({ ...recipe.week }); track("meal_plan_preset_loaded", { preset: recipe.slug }); navigate("/meal-plan"); };
    return (
      <button type="button" data-testid={`load-week-${recipe.slug}`} onClick={loadWeek} className="btn-arcade px-3 py-2 text-xs">
        <CalendarDays size={14} /> Load this week
      </button>
    );
  }
  if (!recipe.ingredients) return null;

  const onPickDay = (day) => {
    const replaced = addMealToPlan(id, day);
    setPicking(false);
    flash(replaced ? `On ${day} (replaced ${replaced.title}) ✓` : `Added to ${day} ✓`);
  };
  const onList = () => {
    const n = addToGrocery(toItems(recipe.ingredients), recipe.listOnly ? "" : recipe.title);
    flash(n ? `${n} item${n > 1 ? "s" : ""} added ✓` : "Already on your list ✓");
  };

  return (
    <div className="flex flex-wrap items-center gap-2 pt-1">
      {!recipe.listOnly && (
        <button type="button" data-testid={`add-to-plan-${recipe.slug}`} onClick={() => setPicking((p) => !p)} className="btn-arcade btn-ghost px-3 py-2 text-xs">
          <CalendarPlus size={14} /> Add to meal plan
        </button>
      )}
      <button type="button" data-testid={`add-to-grocery-${recipe.slug}`} onClick={onList} className="btn-arcade btn-ghost px-3 py-2 text-xs">
        <ListPlus size={14} /> {recipe.listOnly ? "Add all to grocery list" : "Add to grocery list"}
      </button>
      {picking && (
        <div className="w-full flex flex-wrap gap-1" data-testid={`day-picker-${recipe.slug}`}>
          {DAYS.map((d) => (
            <button key={d} type="button" data-testid={`pick-day-${recipe.slug}-${d}`} onClick={() => onPickDay(d)} className="font-mono text-[10px] uppercase tracking-widest border-2 border-white/30 px-2 py-1 hover:border-brand-primary hover:text-brand-primary transition-colors">
              {d}
            </button>
          ))}
        </div>
      )}
      {msg && <span data-testid={`action-msg-${recipe.slug}`} className="font-mono text-[10px] uppercase tracking-widest text-brand-primary">{msg}</span>}
    </div>
  );
};
